export default "/images/foods_provided_sm.jpg?92a8d73fcacc00890129a74576ca5eb3";